export default function standard(key) {
  return function SaveValueToKey(word, value) {
    this.parsed[key] = this.parseValue(value);
  };
}
